import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LocalizationService } from '../../../services/localization.service';
import { Order } from '../models/order';
import { OrderLine } from '../models/order-line';

@Injectable()
export class BasketService {
  constructor(
    private localizationService: LocalizationService,
  ) {
  }

  getGroupHeaderParams(order: Order, date: Date): any {
    if (!order || !order.orderLines) {
      return {};
    }

    const orderLine = order.orderLines.find(x => this.dateToTime(x.bookingDate) === this.dateToTime(date) || (x.eventDateStart && this.dateToTime(x.eventDateStart) === this.dateToTime(date)));
    if (!orderLine || !orderLine.bookingDate) {
      return {};
    }

    const bookingDate = orderLine.eventDateStart ? orderLine.eventDateStart : orderLine.bookingDate;
    const week = this.localizationService.getWeekdayNameShortByDate(bookingDate);
    const weekShort = week.substring(0, Math.min(week.length, 2));
    const month = this.localizationService.getMonthNameLongByDate(bookingDate);
    const monthShort = month.substring(0, Math.min(month.length, 3));
    const pickUpPointGroupName = orderLine.pickupPointGroupName ? '// ' + orderLine.pickupPointGroupName : '';
    const pickUpPointName = pickUpPointGroupName + (orderLine.pickupPointName ? ' // ' + orderLine.pickupPointName : '');

    return {
      prefix: '',
      weekShort: weekShort,
      day: bookingDate.getDate().toString(),
      monthShort: monthShort,
      time: environment.globalSettings.getTimeStr(bookingDate),
      pickUpPointName: pickUpPointName,
    };
  }

  dateToTime(date: Date): number {
    return date ? date.getTime() : 0;
  }

  getDates(order: Order): Date[] {
    if (!order || !order.orderLines) {
      return [];
    }
    return order.orderLines
      .map(orderLine => orderLine.eventDateStart)
      .filter((value, index, self) => self.findIndex(date => this.dateToTime(date) === this.dateToTime(value)) === index)
      .sort((a, b) => this.dateToTime(a) - this.dateToTime(b));
  }

  getOrderLines(order: Order, date: Date): OrderLine[] {
    if (!order || !order.orderLines) {
      return [];
    }
    return order.orderLines.filter(line => this.dateToTime(line.eventDateStart) === this.dateToTime(date));
  }
}
